import React from "react";

function ConfirmationPage() {
  return (
    <div>
      <h1>Form Gönderildi!</h1>
      <p>Faturalar başarıyla yüklendi. Teşekkürler!</p>
    </div>
  );
}

export default ConfirmationPage;
